import Vue from 'vue'

const { axios } = Vue

export function makeover_api_common({ parent_id }) {
    return axios({
        method: "post",
        url: "/makeover/api-common/get-category-list",
        data: { parent_id }
    })
}
// http://test.crm.muniubox.com/makeover/api-buying/query
export function makeover_api_buying_query(condition) {
    return axios({
        method: "post",
        url: "/makeover/api-buying/query",
        data: { ...condition },
    })
}
 
export function makeover_api_buying_create(params) {
    return axios({
        method: "post",
        url: "/makeover/api-buying/create",
        data: { ...params },
    })
}
// 获取省份
export function get_province(parentId) {
    return axios({
        method: "post",
        url: "/api-common/area-all",
        data: {
            parentId
        },
    })
}
